/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-content[_ngcontent-%COMP%]{display:flex;flex:1;height:100px}mat-toolbar[_ngcontent-%COMP%]{min-height:64px}\n/*# sourceMappingURL=app.component.css.map*/"];
export { styles as styles };
